<template>
    <div class="merchant-menu-page">
        <!-- 商户编号搜索区域 -->
        <div class="search-bar">
            <label>商户编号</label>
            <el-input v-model="merchantCode" placeholder="请输入商户编号" style="width: 150px; margin-right: 10px;" clearable
                @keyup.enter.native="handleQuery"></el-input>
            <el-button type="primary" @click="handleQuery" :loading="queryLoading">查询</el-button>
            <el-button @click="handleReset" style="margin-left: 10px;">重置</el-button>
        </div>

        <!-- 菜单列表表格 -->
        <el-table :data="menuList" border style="width: 100%; margin-top: 20px;"
            :header-cell-style="{ background: '#f5f7fa', color: '#333' }" v-loading="tableLoading"
            empty-text="暂无商户菜单数据">
            <el-table-column label="序号" width="60" align="center" :formatter="formatIndex"></el-table-column>
            <el-table-column prop="menuCirculation" label="菜单循环" width="180" align="center"></el-table-column>
            <!-- 消费类型主键列格式化显示 -->
            <el-table-column prop="consumptionTypePK" label="消费类型主键" align="center">
                <template slot-scope="scope">
                    {{ getConsumeTypeName(scope.row.consumptionTypePK) }}
                </template>
            </el-table-column>
            <el-table-column prop="menuId" label="菜单编号" align="center">
                <template slot-scope="scope">
                    <span class="ellipsis" :title="scope.row.menuId">{{ scope.row.menuId }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="menuName" label="菜单名称" align="center"> </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" @click="openPriceDetail(scope.row)"
                        icon="el-icon-view">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container" style="margin-top: 20px; text-align: right;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.totalCount" background
                :disabled="pagination.totalCount === 0"></el-pagination>
        </div>

        <!-- 菜单价格详情弹窗 -->
        <el-dialog title="菜单价格详情" :visible.sync="priceDialogVisible" width="600px" :z-index="2000" append-to-body
            :close-on-click-modal="false">
            <div v-loading="detailLoading">
                <!-- 修正：使用priceDetailList作为表格数据源，而非menuList.menuPrices -->
                <el-table :data="priceDetailList" border style="width: 100%;"
                    :header-cell-style="{ background: '#f5f7fa' }" empty-text="暂无价格详情数据">
                    <!-- 消费类型格式化显示 -->
                    <el-table-column prop="consumptionTypePK" label="消费类型" min-width="200" align="center">
                        <template slot-scope="scope">
                            {{ getConsumeTypeName(scope.row.consumptionTypePK) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="价格" min-width="100" align="center">
                        <template slot-scope="scope">
                            ¥{{ formatPrice(scope.row.price / 100) }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="priceDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'MerchantMenuList',
    data() {
        return {
            merchantCode: 'jbtjbtct001', // 商户编号
            queryLoading: false, // 查询按钮加载状态
            tableLoading: false, // 表格加载状态
            detailLoading: false, // 详情加载状态
            menuList: [], // 菜单列表数据
            priceDialogVisible: false, // 价格详情弹窗显隐控制
            priceDetailList: [], // 价格详情数据（当前选中菜单的menuPrices）
            // 分页参数
            pagination: {
                currentPage: 1, // 当前页码
                pageSize: 10,   // 每页条数
                totalCount: 0   // 总条数
            },
            // 消费类型映射表
            consumeTypeMap: {
                '1': '早餐',
                '2': '午餐',
                '3': '晚餐'
            }
        };
    },
    created() {
        // 初始化加载默认商户的菜单数据
        this.getMerchantMenuList();
    },
    methods: {
        // 格式化序号（分页后正确显示）
        formatIndex(row, column) {
            console.log(column);

            return (this.pagination.currentPage - 1) * this.pagination.pageSize + (this.menuList.indexOf(row) + 1);
        },

        // 价格格式化（保留两位小数）
        formatPrice(price) {
            return (Number(price) || 0).toFixed(2);
        },

        // 根据消费类型值获取对应名称
        getConsumeTypeName(typeValue) {
            // 处理空值、数字/字符串类型兼容
            const typeKey = String(typeValue || '');
            // 若匹配不到则显示原始值，避免空白
            return this.consumeTypeMap[typeKey] || typeValue;
        },

        // 获取商户菜单列表
        async getMerchantMenuList() {
            this.tableLoading = true;
            try {
                const url = 'https://www.zhongyanzhiye.com:8090/chelmeyAI/openAPI/selectMerchantMenu';

                // 构造请求参数
                const requestParams = {
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize,
                    merchantId: this.merchantCode.trim()
                };

                // 发送POST请求
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 如需Token认证，添加以下配置
                        // 'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(requestParams)
                });

                if (!response.ok) {
                    throw new Error(`接口请求失败: ${response.status}`);
                }

                const result = await response.json();

                this.menuList = result.result.rows || [];
                this.pagination.totalCount = result.result.total || 0;

                console.log('商户菜单数据:', result);

            } catch (error) {
                console.error('获取商户菜单失败:', error);
                this.menuList = [];
                this.pagination.totalCount = 0;
                this.$message.error('加载数据失败，请检查网络或稍后重试');
            } finally {
                this.tableLoading = false;
                this.queryLoading = false;
            }
        },

        // 查询按钮点击事件
        handleQuery() {
            if (!this.merchantCode.trim()) {
                this.$message.warning('请输入商户编号');
                return;
            }

            this.queryLoading = true;
            this.pagination.currentPage = 1; // 重置为第一页
            this.getMerchantMenuList();
        },

        // 重置按钮点击事件
        handleReset() {
            this.merchantCode = 'jbtjbtct001'; // 重置为默认商户编号
            this.pagination.currentPage = 1;
            this.getMerchantMenuList();
        },

        // 每页条数改变
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.pagination.currentPage = 1; // 重置页码
            this.getMerchantMenuList();
        },

        // 当前页码改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getMerchantMenuList();
            // 滚动到表格顶部
            window.scrollTo(0, 200);
        },

        // 打开价格详情弹窗（核心修正：读取当前行的menuPrices数组）
        openPriceDetail(row) {
            console.log('菜单详情:', row);
            this.priceDialogVisible = true;
            this.detailLoading = true;

            try {
                // 核心修正：获取当前选中行的menuPrices数据
                this.priceDetailList = row.menuPrices || [];

                // 若没有价格数据，给出友好提示
                if (this.priceDetailList.length === 0) {
                    this.$message.warning('该菜单暂无价格数据');
                }
            } catch (error) {
                console.error('获取价格详情失败:', error);
                this.priceDetailList = [];
                this.$message.error('获取价格详情失败');
            } finally {
                this.detailLoading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.merchant-menu-page {
    padding: 20px;
    background-color: #fff;
    min-height: calc(100vh - 40px);

    .search-bar {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        label {
            margin-right: 10px;
            font-weight: 500;
        }
    }

    // 省略号样式
    .ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        width: 100%;
    }

    // 分页容器样式
    .pagination-container {
        ::v-deep .el-pagination {
            --el-pagination-text-color: #666;
            --el-pagination-button-color: #409eff;
            --el-pagination-button-hover-color: #66b1ff;
        }
    }
}

// 弹窗样式优化
::v-deep .el-dialog {
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

::v-deep .el-dialog__header {
    border-bottom: 1px solid #f0f0f0;
}

::v-deep .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
}

::v-deep .el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

// 加载状态样式
::v-deep .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.8);
}

::v-deep .el-loading-spinner {
    top: 45%;
}

// 表格样式优化
::v-deep .el-table {
    --el-table-row-hover-bg-color: #f8f9fa;
    --el-table-header-text-color: #333;
    --el-table-header-font-weight: 500;
}
</style>